export const style = {
  dialog: {
    maxWidth: 'md',
    sx: {
      '.MuiDialogTitle-root+.css-y9xvel-MuiDialogContent-root': {
        pt: 4,
      },
    },
    circular: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
  },
} as const;
